import React from "react";
import "../../../../css/Turismo/turismo.css";

const imagenes = [
  require("../../../img/patronales/fiesta-patronales-1.NEF"),
  require("../../../img/patronales/fiesta-patronales-2.jpeg"),
  require("../../../img/patronales/fiesta-patronales-3.jpeg"),
  require("../../../img/patronales/fiesta-patronales-4.jpeg"),
  require("../../../img/patronales/fiesta-patronales-5.jpeg"),
  require("../../../img/patronales/fiesta-patronales-6.jpeg"),
  require("../../../img/patronales/fiesta-patronales-7.jpeg"),
  require("../../../img/patronales/fiesta-patronales-8.jpeg"),
  require("../../../img/patronales/fiesta-patronales-9.jpeg"),
  require("../../../img/patronales/fiesta-patronales-10.jpeg"),
];

const FiestaPatronal = () => (
  <div>
    <div
      className="patronales text-center"
      style={{
        backgroundImage: `url(${require("../../../img/fiesta-patronales-2.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "-140px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 450,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 1,
        }}
      />
    </div>
    <div className="container">
      <div className="info-patronales">
        <h1 className="text-center"><strong>FIESTA PATRONAL</strong></h1>
        <p>
          Las Fiestas Patronales de la Ciudad de Oliva se celebran en el mes de junio, en honor al patrono 
          de la Ciudad, Sagrado Corazón de Jesús. Es una celebración religiosa en donde se realiza la tradicional procesión al frente de la Parroquia, 
          al finalizar la Municipalidad de Oliva lleva a cabo una grilla de actividades 
          en la plaza Presbítero Visca Caviglia, entre ellas: Ferias de artesanos y emprendedores
          locales, entrega de chocolate caliente, diferentes desfiles entre otros más. 
        </p>
        <p>
          La Celebración al Sagrado Corazón de Jesús no tiene fecha fija, por lo que se celebra cada año el
          día viernes después del segundo domingo de Pentecostés. 
        </p>
        <div className="row">
          <section className="col-12">
            <div id="carouselPatronales" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {imagenes.map((img, idx) => (
                  <div className={`carousel-item${idx === 0 ? " active" : ""}`} key={idx}>
                    <img src={img} alt={`fiesta-patronal-${idx + 1}`} style={{ width: "100%", height: "auto", objectFit: "cover" }} />

                  </div>
                ))}
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselPatronales" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselPatronales" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default FiestaPatronal;